import { useCallback, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import type { RootState } from '@/store/';
import { updateLocationAndCityInfo } from '@/store/addressSlice';
import type { LocationInfo } from '@/utils';
import { channelGetLocationInfo } from '@/channels';
import { fetchCityInfo } from '@/apis/address';
import { fetchNearByStores } from '@/apis/canteen';
import { isDouyinAppChannel } from '../channels/code';

// const defaultCityInfo = {
//   code: '310100',
//   hasStores: 1,
//   isHotCity: 1,
//   latitude: 31.230525,
//   longitude: 121.473667,
//   name: '上海市',
// };

const useLocationInfo = () => {
  const locationAndCityInfo = useSelector((state: RootState) => state.address.locationAndCityInfo);
  const dispatch = useDispatch();

  const locationAndCityInfoRef = useRef(locationAndCityInfo);
  locationAndCityInfoRef.current = locationAndCityInfo;

  useEffect(() => {
    if (
      (!locationAndCityInfoRef.current || !locationAndCityInfoRef.current?.hadFetch) &&
      !locationAndCityInfoRef.current?.loading
    ) {
      getLocationAndCityInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleErr = useCallback(() => {
    dispatch(
      updateLocationAndCityInfo({
        ...locationAndCityInfo,
        hadFetch: true,
        loading: false,
      }),
    );
  }, [dispatch, locationAndCityInfo]);

  const getCityByLocation = useCallback(
    (p: LocationInfo) => {
      console.log('fetchCityInfo', p);
      fetchCityInfo({ ...p })
        .then((data) => {
          console.log('fetchCityInfo', data);
          const { city } = data || {};
          if (!city) {
            dispatch(
              updateLocationAndCityInfo({
                hadFetch: true,
                loading: false,
                latitude: p.latitude,
                longitude: p.longitude,
                message: '无法获取城市信息',
              }),
            );
            return;
          }
          const { code, name, latitude, longitude } = city || {};

          const orderType = isDouyinAppChannel() ? '2' : '';
          fetchNearByStores({ latitude: p?.latitude, longitude: p?.longitude, distance: 10000, showType: 2, orderType })
            .then((res) => {
              // eslint-disable-next-line @typescript-eslint/no-shadow
              const { data, message } = res || {};
              const { stores } = data || {};
              console.log('fetchNearByStores', res);
              dispatch(
                updateLocationAndCityInfo({
                  hadFetch: true,
                  loading: false,
                  latitude: p.latitude,
                  longitude: p.longitude,
                  city: {
                    code,
                    name,
                    latitude,
                    longitude,
                  },
                  nearestStoreInfo: stores ? stores[0] : undefined,
                  stores: stores || [],
                  message: message || '',
                }),
              );
            })
            .catch((err: Error) => {
              console.log('err', err);
              dispatch(
                updateLocationAndCityInfo({
                  hadFetch: true,
                  loading: false,
                  latitude: p.latitude,
                  longitude: p.longitude,
                  city: {
                    code,
                    name,
                    latitude,
                    longitude,
                  },
                  message: err.message || '',
                }),
              );
            });
        })
        .catch((e) => {
          handleErr();
        });
    },
    [dispatch, handleErr],
  );

  const getLocationAndCityInfo = useCallback(() => {
    dispatch(
      updateLocationAndCityInfo({
        ...locationAndCityInfo,
        loading: true,
      }),
    );
    channelGetLocationInfo()
      .then((res) => {
        console.log('getLocationInfo', res);
        getCityByLocation(res);
      })
      .catch((e) => {
        console.log('getLocationInfo: ERR', e);
        handleErr();
      });
  }, [getCityByLocation, handleErr, dispatch, locationAndCityInfo]);

  return { locationAndCityInfo, refetch: getLocationAndCityInfo };
};

export default useLocationInfo;
